module.exports = __webpack_public_path__ + "static/img/icon_drawer.9e81fc9d.png";